import { MOCK_DASHBOARD_DATA } from "../data/mock_dashboard";

let aggregatorURL = import.meta.env.VITE_AGGREGATOR_URL;
if (import.meta.env.DEV && aggregatorURL === undefined) {
  aggregatorURL = "http://localhost:3300";
}

export const calculateProfilePercentages = (profiles = []) => {
  const percentages = {};

  for (let profile = 1; profile <= 5; profile += 1) {
    percentages[profile] = { percentage: 0, count: 0 };
  }

  if (!Array.isArray(profiles) || profiles.length === 0) {
    return percentages;
  }

  let totalCount = 0;

  profiles.forEach((item) => {
    const profileId = item?.profile;
    const count = item?.count ?? 0;

    if (DEFAULT_PROFILE_IDS.includes(profileId)) {
      percentages[profileId].count += count;
      totalCount += count;
    }
  });

  if (totalCount === 0) {
    return percentages;
  }

  for (let profile = 1; profile <= 5; profile += 1) {
    const count = percentages[profile].count;
    percentages[profile].percentage = Number(
      ((count / totalCount) * 100).toFixed(2),
    );
  }

  return percentages;
};

const DEFAULT_PROFILE_IDS = [1, 2, 3, 4, 5];
const DEFAULT_ACTION_IDS = [1, 2, 3, 4];

export const calculateActionPercentages = (
  actions = [],
  { profiles = DEFAULT_PROFILE_IDS, actionIds = DEFAULT_ACTION_IDS } = {},
) => {
  let profileIds = profiles
    .map((profile) => profile)
    .filter((profileId) => profileId > 0);

  let resolvedActionIds = actionIds
    .map((action) => action)
    .filter((actionId) => actionId > 0);

  const percentages = {};

  profileIds.forEach((profileId) => {
    percentages[profileId] = { count: 0, actions: {} };
    resolvedActionIds.forEach((actionId) => {
      percentages[profileId].actions[actionId] = { count: 0, percentage: 0 };
    });
  });

  actions.forEach((item) => {
    const profileId = item?.profile;
    const actionId = item?.action;
    const count = item?.count ?? 0;

    if (!percentages[profileId]) {
      percentages[profileId] = { count: 0, actions: {} };
      resolvedActionIds.forEach((id) => {
        percentages[profileId].actions[id] = { count: 0, percentage: 0 };
      });
    }

    if (!percentages[profileId].actions[actionId]) {
      percentages[profileId].actions[actionId] = { count: 0, percentage: 0 };
    }

    percentages[profileId].count += count;
    percentages[profileId].actions[actionId].count += count;
  });

  Object.values(percentages).forEach((profileData) => {
    const total = profileData.count;

    Object.values(profileData.actions).forEach((actionData) => {
      actionData.percentage =
        total === 0 ? 0 : Number(((actionData.count / total) * 100).toFixed(2));
    });
  });

  return percentages;
};

export const fetchData = async (groupCode) => {
  let payload;
  if (import.meta.env.VITE_MOCK_AGGREGATOR) {
    payload = MOCK_DASHBOARD_DATA;
  } else {
    const response = await fetch(
      `${aggregatorURL}/edubox/digital-wellbeing/${groupCode}`,
      {
        headers: {
          Authorization: `token ${import.meta.env.VITE_AGGREGATOR_KEY}`,
        },
      },
    );

    payload = await response.json();
  }

  const transformed = { ...payload };

  if (Array.isArray(payload?.profiles)) {
    transformed.profiles = calculateProfilePercentages(payload.profiles);
  }

  const actionKeys = ["actionHabits", "actionEnvironment", "actionDevices"];
  actionKeys.forEach((key) => {
    if (Array.isArray(payload?.[key])) {
      transformed[key] = calculateActionPercentages(payload[key]);
    }
  });

  return transformed;
};
